import { call, put, takeLatest, cancelled } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../services/apis";

function* handleFetchDetailed(action) {
  try {
    
    const { filtersString } = action.payload;
    const response = yield call(API.fetchTestingAnalyticsDetailed, filtersString);
    const responseData = response?.data;
    const rawData = responseData?.data || responseData || {};
    
    yield put(actions.fetchDetailedSuccess({ 
      data: rawData
    }));
    
  } catch (error) {
    // Check if the task was cancelled
    if (yield cancelled()) {
      return;
    }
    yield put(actions.fetchDetailedFailure(error.message || "Failed to load data"));
  }
}

export function* testingAnalyticsDetailedSaga() {
  // Use takeLatest to cancel previous requests automatically
  yield takeLatest(actions.fetchDetailed.type, handleFetchDetailed);
}